/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-23 16:41:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-30 14:55:41
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/NoticeBoard/index.tsx
 */
import React from 'react';
import css from './css.module.less';

import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Input, TextArea } from 'src/components/Antd';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import TipsAndSwitch from 'src/constrains/SalesChannelPreviewPageComponents/TipsAndSwitch';
import Tip from 'src/pages/SalesChannelContentEditor/Components/DisabledSectionTip';
import { validateNoticeBorder } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getNoticeBoard,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onNoticeBoardChange,
} from '../slice';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './css.module.less';
const NoticeBoard = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const { data, specificError, isPrimary, withoutCollapse } = props;
  const { contentError = [], titleError = [] } = specificError || {};

  const { enabled, title, content } = data || {};

  const handleOnEnabledChange = (enabled) => {
    _d(onNoticeBoardChange({ enabled }));
  };
  const handleOnTitleChange = (title) => {
    _d(onNoticeBoardChange({ title }));
  };
  const handleOnContentChange = (content) => {
    _d(onNoticeBoardChange({ content }));
  };

  return (
    <React.Fragment>
      {isPrimary && (
        <Section
          bottomBorder={!withoutCollapse}
          className={withoutCollapse ? styles.fieldSection1 : ''}>
          <TipsAndSwitch
            enabled={enabled}
            onChange={handleOnEnabledChange}
            title={getI18n('general.hOCTitle.noticeboard')}
            content={getI18n('salesChannelContent.index.noticeboardSubtitle')}
          />
        </Section>
      )}
      {!isPrimary && !enabled && (
        <Section>
          <Tip
            className={css.tipClassName}
            tip={getI18n(
              'salesChannelContent.index.noticeboardunderprimarylang',
            )}
          />
        </Section>
      )}
      {enabled && (
        <Section className={withoutCollapse ? styles.fieldSection2 : ''}>
          <ItemWrapper
            title={`${getI18n('general.title')}*`}
            rightPart={
              <CountWords count={(title || '').length} allCount={100} />
            }>
            <Input
              error={titleError.length > 0}
              help={getI18n('salesChannelContent.index.titlecannotbeempty')}
              maxLength={100}
              value={title}
              onChange={handleOnTitleChange}
              size='large'
            />
          </ItemWrapper>
          <ItemWrapper
            title={`${getI18n('general.sider.content')}*`}
            rightPart={
              <CountWords count={(content || '').length} allCount={1000} />
            }>
            <TextArea
              error={contentError.length > 0}
              help={getI18n('salesChannelContent.index.contentcannotbeempty')}
              value={content}
              maxLength={1000}
              onChange={handleOnContentChange}
              autoSize={{ minRows: 3, maxRows: 10 }}
            />
          </ItemWrapper>
        </Section>
      )}
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(NoticeBoard, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.noticeBoard,
  getContent: getNoticeBoard,
  title: getI18nFromGeneral('general.hOCTitle.noticeboard'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: validateNoticeBorder,
  getSubmitStamp,
});
